import moment from "moment";
import CryptoJS from "crypto-js";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

export const formatedDate = date => {
  const format = moment(date).format("YYYY-MM-DD");
  return format;
};

export const formatDateTime = date => {
  return moment(date).format("MMM D,YYYY hh:mm A");
};

export const dateFromNow = date => {
  return moment(date).fromNow();
};

export const formatAgeYear = (data, age) => {
  const currentDate = moment();
  const registeredDate = moment(data);

  // Function to parse age string
  const parseAgeString = ageStr => {
    const ageUnits = ageStr.toLowerCase().split(/[\s-]+/);
    const duration = {};
    ageUnits.forEach(unitStr => {
      const parts = unitStr.match(/(\d+)\s*([a-z]+)/);
      if (parts) {
        const value = parseInt(parts[1]);
        const unit = parts[2];
        if (unit.startsWith("y"))
          duration.years = (duration.years || 0) + value;
        else if (unit.startsWith("m"))
          duration.months = (duration.months || 0) + value;
        else if (unit.startsWith("d"))
          duration.days = (duration.days || 0) + value;
      }
    });
    return duration;
  };

  // If age is a string (like "1DAY", "1MONTH", "1YEAR", "1YEAR-2MONTH")
  if (typeof age === "string") {
    // Check if the age string is a number
    if (!isNaN(age)) {
      const ageNumber = parseInt(age);
      const birthDate = registeredDate.clone().subtract(ageNumber, "years");
      const currentAge = currentDate.diff(birthDate, "years");
      return currentAge + (currentAge === 1 ? "Yr" : "Yrs");
    }

    const parsedAge = parseAgeString(age);
    if (parsedAge) {
      const birthDate = registeredDate.clone().subtract(parsedAge);
      const ageInYears = currentDate.diff(birthDate, "years");
      const ageInMonths = currentDate.diff(birthDate, "months") % 12;
      const ageInDays = currentDate.diff(birthDate, "days") % 30;

      if (ageInYears > 0) {
        let result = ageInYears + (ageInYears === 1 ? "Yr" : "Yrs");
        if (ageInMonths > 0) {
          result +=
            "-" + ageInMonths + (ageInMonths === 1 ? "Month" : "Months");
        }
        return result;
      } else if (ageInMonths > 0) {
        let result = ageInMonths + (ageInMonths === 1 ? "Month" : "Months");
        if (ageInDays > 0) {
          result += "-" + ageInDays + (ageInDays === 1 ? "Day" : "Days");
        }
        return result;
      } else {
        const totalDays = currentDate.diff(birthDate, "days");
        if (totalDays > 30) {
          const months = Math.floor(totalDays / 30);
          const remainingDays = totalDays % 30;
          return `${months}Month${months > 1 ? "s" : ""}-${remainingDays}Day${
            remainingDays > 1 ? "s" : ""
          }`;
        } else {
          return Math.max(1, totalDays) + (totalDays === 1 ? "Day" : "Days");
        }
      }
    }
  }

  // If age is a number or a string that can be parsed as a number
  if (!isNaN(parseFloat(age))) {
    const ageNumber = parseFloat(age);
    const birthDate = registeredDate.clone().subtract(ageNumber, "years");
    const currentAge = currentDate.diff(birthDate, "years");
    if (currentAge >= 1) {
      return currentAge + (currentAge === 1 ? "Yr" : "Yrs");
    } else {
      // For ages less than 1, convert to days
      const days = Math.round(currentDate.diff(birthDate, "days"));
      return days + (days === 1 ? "Day" : "Days");
    }
  }

  // If age format is unrecognized, return original age
  return age;
};

export const formatNumbers = number =>
  number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";

const gender = {
  male: "1",
  female: "2"
};

export const formatGender = value => {
  return `${
    value == gender.male ? "Male" : value == gender.female ? "Female" : ""
  }`;
};

export const getGender = value => {
  return `${
    value.toLowerCase() == "male" ? 1 : value.toLowerCase() == "female" ? 2 : ""
  }`;
};

export const formatedIsOther = id => {
  return id == 6 ? 1 : 0;
};

export const formatedStatus = (status, userStatus, ledger) => {
  if (status == 1) {
    return userStatus ? "Active" : ledger ? "Unpaid" : "In Process";
  } else if (status == 2 || status == 5) {
    return userStatus ? "Deactive" : ledger ? "Paid" : "In Queue";
  } else if (status == 3) {
    return userStatus ? "" : "Processed";
  } else if (status === 4) {
    return "Cancel";
  } else if (status == 7) {
    return "Study Canceled";
  }
};

export const status = value => {
  return `${
    value.toLowerCase() == "active"
      ? 1
      : value.toLowerCase() == "deactive"
      ? 2
      : ""
  }`;
};

export const skip = val => {
  if (val == 1) {
    return 0;
  } else if (val > 1) {
    return val * 20 - 20;
  }
};

export const convertoHtml = val => {
  const cfg = {
    inlineStyles: true
  };
  const converter = new QuillDeltaToHtmlConverter(val && val.ops, cfg);
  return converter.convert();
};

export const getPercentage = (sum, percent) => {
  const total = (sum * percent) / 100;
  return total.toFixed(2);
};

function discountPrice(sum, discount) {
  let disc = discount ? discount : 0;
  if (/[0-9]*\.?[0-9]+%/.test(discount)) {
    if (parseFloat(discount) <= 100 && parseFloat(discount) >= 0) {
      let discountPrice = parseFloat(discount) / 100;
      return sum - sum * discountPrice;
    }
  } else {
    return sum - disc;
  }
}

export const totalDiscount = (sum, subtotal) => {
  if (subtotal) {
    return sum - subtotal;
  }
};

export const formatExpenseType = val => {
  if (val) {
    return val.toLowerCase() == "credit"
      ? 2
      : val.toLowerCase() === "debit"
      ? 1
      : "";
  }
};

export const formatCreditDebit = val => {
  return val == 2 ? "Credit" : val === 1 ? "Debit" : "";
};

export const handleDiscountedPrice = (val, id, rows) => {
  const rowsState = [...rows];
  const index = rowsState.findIndex(i => i.id == id);
  if (index > -1 && rowsState[index].subtotal) {
    rowsState[index].discountValue = val;
    const priceValue = rowsState[index].price;
    rowsState[index].subtotal = discountPrice(priceValue, val);
    rows = rowsState;
  }
};

export const handleQuantityNumber = (val, id, rows) => {
  const rowsState = [...rows];
  const index = rowsState.findIndex(i => i.id == id);
  if (
    index > -1 &&
    rowsState[index].subtotal &&
    !rowsState[index].discountPercentageValue
  ) {
    rowsState[index].quantityNumber = val;
    rowsState[index].subtotal = val * rowsState[index].price;
    rows = rowsState;
  } else if (index > -1 && rowsState[index].subtotal) {
    rowsState[index].quantityNumber = val;
    const total = val * rowsState[index].price;
    const test = total * (rowsState[index].discountPercentageValue / 100);
    const subtotal = total - test;
    const discountAmount = total - subtotal;
    rowsState[index].discountValue = discountAmount;
    rowsState[index].subtotal = subtotal;
    rows = rowsState;
  }
};

export const handleRows = (val, id, rows) => {
  const rowsState = [...rows];
  const index = rowsState.findIndex(i => i.id === id);
  if (index > -1) {
    rowsState[index].price = val.amount;
    rowsState[index].subtotal = val.amount;
    rowsState[index].name = val.name;
    rowsState[index].lookup = val.lookup;
    rowsState[index].chargeId = val.chargeId;
    rowsState[index].lookupId = val.lookupId;
    rowsState[index].amount = val.amount;
    rows = rowsState;
  }
};

export const sum = rows => {
  let total = 0;
  let sum = [];
  rows?.map(row => {
    sum.push(parseFloat(row?.subtotal));
    total = sum.reduce((acc, curr) => acc + curr, 0);
  });
  return total.toLocaleString();
};

export const sumRows = rows => {
  let sum = 0;
  rows.map(row => {
    const value = parseFloat(row);
    sum += value;
  });
  return sum;
};

export const downloadPdf = url => {
  if (url && url !== null) {
    // The file host is cross-origin, so the <a download> attribute is
    // ignored and clicking it navigates the app tab to the PDF — losing
    // the session if the host is unreachable. Open in a new tab instead:
    // the native PDF viewer there handles printing and downloading, and a
    // broken link only kills the new tab, not the app.
    window.open(url, "_blank", "noopener");
  }
};

export const encryptData = (obj, key) => {
  if (obj != null && key !== undefined) {
    const encrypt = CryptoJS.AES.encrypt(JSON.stringify(obj), key).toString();
    return encrypt;
  }
};

export const decryptData = (obj, key) => {
  if (obj != null && obj !== undefined && key != undefined) {
    const bytes = CryptoJS.AES.decrypt(obj, key);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  }
};

export const titleCase = string => {
  const text = string ? string.trim().replace(/[^\w\s]/gi, " ") : "";
  return text
    .toLowerCase()
    .split(" ")
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ");
};

export const generateRandomDigits = (length = 4) => {
  let digits = "";
  for (let i = 0; i < length; i++) {
    digits += Math.floor(Math.random() * 10);
  }
  return digits;
};
export const getBranchLogo = (data, branchId) => {
  const url = data.find(obj => obj.id === branchId)?.logoPath;
  return url;
};

export const calculateDiscountPercent = (totalAmount, discountAmount) => {
  let discountPercent = (discountAmount / totalAmount) * 100;
  return discountPercent;
};
